import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { SubpageBanner, SectionHeader } from 'components';

const Banner = () => (
  <StaticQuery
    query={graphql`
      query {
        mainBannerImage: file(
          relativePath: { eq: "development-teams/dt-mvp-team-big.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <SubpageBanner
        backgroundColor={'red'}
        image={data.mainBannerImage.childImageSharp.fluid}
        contentBackground={'gray-light'}
        additionalClass={'development-teams__banner'}
        alt={'Development team'}
      >
        <SectionHeader
          size={'large'}
          color={'mine-shaft'}
          lineColor={'red'}
          description={
            'Boldare’s digital product development teams will help you conceptualize your idea, design and build the first version of your product, find a product-market fit, and develop a scalable web product. Furthermore, the teams will guide you all the way, advising on next steps and passing on their know-how so you can grow sustainably in the future.'
          }
          hiddenDescription={
            '<br />Our agile development team will take you through the full cycle of product development using a lean startup approach. Thanks to the lean methodology our teams can develop a product within as little as 4 weeks so you can enter the market quickly and start testing with real users.'
          }
          descriptionColor={'black'}
          buttonColor={'black'}
          fixed
          additionalClass={'section-header__description--medium'}
        >
          Development
          <br />
          Teams
        </SectionHeader>
      </SubpageBanner>
    )}
  />
);

export default Banner;
